'use client';

import dynamic from 'next/dynamic';

/**
 * We must use `next/dynamic` with `ssr: false` because these components depend on browser APIs,
 * so they can only run client-side.
 */

export const Editor = dynamic(() => import('./Editor'), {
    ssr: false,
});

export const EditorContextProvider = dynamic(
    () =>
        import('./state/EditorContext').then(
            (mod) => mod.EditorContext.Provider,
        ),
    {
        ssr: false,
    },
);

// This export needs to be referenced directly, instead of via ./hooks/index.ts, so that it won't
// break the web app due to NextJS's module loading during SSR.
export { useFileBrowser } from './hooks/useFileBrowser';

// Pure utility classes with no browser API dependencies — safe for direct export.
export { DeviceMutex } from './state/utils/deviceMutex';
export { SerialTransaction } from './state/utils/serialTransaction';
export { MpRawMode, MpRawModeError } from './state/utils/mpRawMode';
export { TerminalFormatter } from './state/utils/terminalFormatter';
export {
    listFilesystem,
    readFileFromDevice,
    writeFileToDevice,
    readFileWithVerification,
    writeFileWithVerification,
    deleteFileOnDevice,
    createDirectoryOnDevice,
    deleteDirectoryOnDevice,
    checkReadOnly,
    loadDeviceInfoFromDevice,
} from './state/utils/fileOps';
export type { DeviceInfoResult } from './state/utils/fileOps';
export {
    loadHashCache,
    getHashCacheForDevice,
    flushHashCachePersistence,
} from './state/utils/fileIntegrity';
export {
    runCurrentFile as runCurrentFileNew,
    stopExecution as stopExecutionNew,
    resetREPL as resetREPLNew,
    softReset as softResetNew,
} from './state/utils/codeExecution';
